import { IraUser, FullName } from 'services/requests';
import { convertDate, formatUSD, mapCustodianTypeKeyToValue, userStatus } from 'utils';
import { USER_TYPE } from 'constants/userTypes';
import TableSorting from 'components/Table/TableElements/TableSorting';
import TableActionMenu from 'components/Table/TableElements/TableActionMenu';
import { CustomColumn } from 'components/Table/Table.types';
import styles from './IraUsersTable.module.css';

export type MapData = IraUsersTableSign[];
export type IraUsersTableSign = Omit<IraUser, 'balance'> &
  FullName & {
    icon: JSX.Element;
    balance: string;
  };

// TODO: Refactor user tables for using 1 table

export const mapData = (
  data: IraUser[] | undefined,
  onEdit: (user: IraUser) => void,
  prefetch: (id: string) => void,
): MapData | undefined =>
  data?.map((user: IraUser) => ({
    ...user,
    fullName: `${user.firstName} ${user.middleName ? user.middleName : ''} ${
      user.lastName
    }`,
    profileStatus: userStatus(user.profileStatus),
    custodianType: mapCustodianTypeKeyToValue(user.custodianType),
    balance: formatUSD(user.balance),
    created: convertDate(user.created),
    lastLogin: convertDate(user?.lastLogin),
    icon: (
      <TableActionMenu
        user={user}
        onEdit={onEdit}
        onPrefetch={prefetch}
        userType={USER_TYPE.iraUser}
      />
    ),
  }));

type Columns = CustomColumn<IraUsersTableSign>[];
export const columns: Columns = [
  {
    Header: <TableSorting sortingFieldKey={'fullName'} sortingFieldName={'Name'} />,
    accessor: 'fullName',
    className: styles.fullNameColumn,
  },
  {
    Header: 'Username',
    accessor: 'userName',
    className: styles.usernameColumn,
  },
  {
    Header: 'Email',
    accessor: 'email',
    className: styles.emailColumn,
  },
  {
    Header: 'Status',
    accessor: 'profileStatus',
    className: styles.profileStatusColumn,
  },
  {
    Header: 'Account number',
    accessor: 'accountNumber',
    className: styles.accountNumberColumn,
  },
  {
    Header: 'Custodian',
    accessor: 'custodianType',
    className: styles.custodianTypeColumn,
  },
  {
    Header: <TableSorting sortingFieldKey={'balance'} sortingFieldName={'Balance'} />,
    accessor: 'balance',
    className: styles.balanceColumn,
  },
  {
    Header: <TableSorting sortingFieldKey={'created'} sortingFieldName={'Created'} />,
    accessor: 'created',
    className: styles.createdColumn,
  },
  {
    Header: (
      <TableSorting sortingFieldKey={'lastLogin'} sortingFieldName={'Last login'} />
    ),
    accessor: 'lastLogin',
    className: styles.lastLoginColumn,
  },
  {
    Header: '',
    accessor: 'icon',
    className: styles.iconColumn,
  },
];
